const { darken, lighten } = require("polished");

// Used so hover colors get automatically updated
const brandPrimaryColor = "#202945";
const brandSecondaryColor = "#e73843";
const brandTertiaryColor = "#00893E";
const brandQuaternaryColor = "#75AB3B";

const brandBlackColor = "#000000";
const brandGreyColor = "#d8dfe1";
const brandWhiteColor = "#FFFFFF";

const colors = {
    // Brand & Accent
    "brand-primary": brandPrimaryColor,
    "brand-secondary": brandSecondaryColor,
    "brand-tertiary": brandTertiaryColor,
    "brand-quaternary": brandQuaternaryColor,

    // Base
    "brand-black": brandBlackColor,
    "brand-dark-grey": "#999999",
    "brand-grey": brandGreyColor,
    "brand-light-metal-grey": "#EBEFF0",
    "brand-light-grey": "#FAFAFA",
    "brand-white": brandWhiteColor,

    // Messages
    "brand-success": "#2DB200",
    "brand-warning": "#F49C10",
    "brand-danger": "#E73843",
    "brand-info": "#0079C2",

    // Alerts
    "brand-success-alert": "#E9F7E5",
    "brand-warning-alert": "#FEF5E6",
    "brand-danger-alert": "#FCE5E7",
    "brand-info-alert": "#E5F4FC",

    // Alert Borders
    "brand-success-alert-border": "#D5F0CE",
    "brand-warning-alert-border": "#FDECD0",
    "brand-danger-alert-border": "#F9CED2",
    "brand-info-alert-border": "#CEEAF9",

    // Checkbox Count
    "brand-checkbox-count": "#909090",

    // Links
    "brand-link-visited": "#3200C2",

    // Lighten & Darken
    "brand-primary-lighten": lighten(0.05, brandPrimaryColor),
    "brand-primary-darken": darken(0.05, brandPrimaryColor),

    "brand-secondary-lighten": lighten(0.05, brandSecondaryColor),
    "brand-secondary-darken": darken(0.05, brandSecondaryColor),

    "brand-tertiary-lighten": lighten(0.05, brandTertiaryColor),
    "brand-tertiary-darken": "#00441F",

    "brand-quaternary-lighten": lighten(0.05, brandQuaternaryColor),
    "brand-quaternary-darken": "#304B32",

    "brand-black-lighten": lighten(0.05, brandBlackColor),
    "brand-black-darken": darken(0.05, brandBlackColor),

    "brand-grey-lighten": lighten(0.05, brandGreyColor),
    "brand-grey-darken": darken(0.05, brandGreyColor),

    "brand-white-lighten": lighten(0.05, brandWhiteColor),
    "brand-white-darken": darken(0.05, brandWhiteColor),
};

const fonts = {
    heading: ["TambaSansBold"],
    body: ["TambaSansLight"],
};

module.exports = { colors, fonts };
